import { css } from '@emotion/react'
import {
  Color,
  Shadow,
  ShadowElevation,
  Size,
  Spacing,
  Typography,
} from '@opallabs/gem'

export const weekTooltipContentStyle = css({
  backgroundColor: Color.dark.Surface.N000,
  borderRadius: Size.Rounding,
  color: Color.light.Text.InvertedDefault,
  maxInlineSize: Spacing.XS * 75,
  paddingBlock: Spacing.XS,
  paddingInline: Spacing.S,
  ...Typography.T300,
  ...Shadow[ShadowElevation.E2],
})
